import type { IWhereUsedSectionTab } from '~/components/pages/directions/where-used-section/where-used-section.types'

const WHERE_USED_ARENDA_CONFERENCE_SYSTEM: IWhereUsedSectionTab[] = [
    {
        title: 'Конференции',
        image: '/assets/images/usage/conference-system/jpg-png/negotiating-table-3.jpg',
        image_webp:
            '/assets/images/usage/conference-system/webp/negotiating-table-3.webp',
        text: `
                <p>В&nbsp;большинстве случаев микрофонные пульты для конференц-систем Bosch DCN располагаются в&nbsp;президиуме. Конденсаторные микрофоны с&nbsp;высокой чувствительностью делают речь докладчиков четко различимой. Кроме того, элегантный и&nbsp;профессиональный дизайн пультов прекрасно гармонирует как с&nbsp;столами, так и&nbsp;с&nbsp;тем, что попадает в&nbsp;объективы камер. Взяв у&nbsp;нас в&nbsp;аренду конференц-систему Bosch, вы&nbsp;значительно повышаете статус мероприятия.</p>
            `,
    },
    {
        title: 'Переговоры',
        image: '/assets/images/usage/conference-system/jpg-png/negotiating-table-4.jpg',
        image_webp:
            '/assets/images/usage/conference-system/webp/negotiating-table-4.webp',
        text: `
                <p>Председательский пульт конференц-системы Bosch оборудован специальной кнопкой, которая позволяет отключить все активные микрофоны. Это становится особенно полезным в&nbsp;ситуациях, когда во&nbsp;время эмоциональных переговоров возникает напряжение и&nbsp;споры. Таким образом, аренда конференц-системы, позволяет быстро восстановить спокойствие и&nbsp;поддерживать продуктивную атмосферу для дальнейших обсуждений.</p>
            `,
    },
    {
        title: 'Лекции',
        image: '/assets/images/usage/conference-system/jpg-png/speech-2.jpg',
        image_webp: '/assets/images/usage/conference-system/webp/speech-2.webp',
        text: `
                <p>Конденсаторный капсюль с&nbsp;высокой чувствительностью у&nbsp;микрофона способен уловить все детали речи выступающего. Установив всего один микрофон конференц-системы Bosch на&nbsp;трибуне, можно обеспечить отличное качество звука во&nbsp;время лекции. Кроме того, благодаря гибкой ножке, можно легко отрегулировать высоту и&nbsp;положение микрофона под каждого лектора. У&nbsp;нас взять в&nbsp;прокат можно даже один микрофон конференц-системы.</p>
            `,
    },
    {
        title: 'Круглый стол',
        image: '/assets/images/usage/conference-system/jpg-png/negotiating-table-5.jpg',
        image_webp:
            '/assets/images/usage/conference-system/webp/negotiating-table-5.webp',
        text: `
                <p>Когда речь идет о&nbsp;размещении участников мероприятия по&nbsp;схеме &laquo;круг&raquo;, следует обратить внимание на&nbsp;важный аспект&nbsp;&mdash; минимизацию количества кабелей от&nbsp;микрофонов. В&nbsp;такой конфигурации их&nbsp;может оказаться достаточно много, так как все устройства сосредоточены в&nbsp;одной области.</p>
                <p>Для упрощения этой задачи часто применяются конференц-системы, которые берутся в&nbsp;аренду. Они позволяют соединять пульты последовательно, образуя цепочку. В&nbsp;итоге, от&nbsp;последнего микрофона к&nbsp;центральному блоку управления прокладывается лишь один кабель. Это значительно облегчает организацию и&nbsp;делает пространство более аккуратным. Возьмите в&nbsp;прокат конференц-систему и&nbsp;очистите пространство)</p>
            `,
    },
]

export default WHERE_USED_ARENDA_CONFERENCE_SYSTEM
